const types = 'Array Object String Date RegExp Function Boolean Number Null Undefined'.split(' ');

export default function getType(val) {
  // NaN-check is tricky, NaN !== NaN
  // http://stackoverflow.com/a/2801629
  if (isNaN(val) && val !== val) return 'nan'; // eslint-disable-line
  return Object.prototype.toString.call(val).replace(/\[object (.*)\]/, '$1').toLowerCase();
}

export const type = types.reduce((exports, currType) => {
  return {
    ...exports,
    [`is${currType}`]: val => getType(val) === currType.toLowerCase(),
  };
}, { isNaN: (val) => (getType(val) === 'nan') });



/** WEBPACK FOOTER **
 ** ./modules/util/typecheck.js
 **/